import React, { Component } from 'react';
import moment from 'moment';
import Page from '../../containers/page';
import ListBuilder from '../../components/listBuilder';
import { Link } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, Table
} from 'reactstrap';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import ErrorModal from '../../components/errorModal';
import profileUser from "../../assets/images/user.png";
import warrning from '../../assets/svg/warrning.svg';
import Isvg from 'react-inlinesvg';
import attach from '../../assets/svg/attach.svg';
import { Player } from '@lottiefiles/react-lottie-player';
import File from '../../components/forms/fields/multipleFilesSupport'

var striptags = require('striptags');
function parseJSONUpload(response) {
    if (response?.status === 500) {
        return { error: 'Wrong file type!' }
    } else {
        return response.json()
    }
}
function parseTextUpload(response) {
    if (response?.status === 500) {
        return { error: 'Wrong file type!' }
    } else {
        return response.text()
    }
}


/**
* Support page
* @author   Stefan Pantic
*/
class HomePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotedProjects: [],
            ...props.initialData,
            form: false,

            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            tikets: [],
            category: {},
            messages: [],
            sentList: true,
            doctorTikets: [],
            imageTicket: [],
            documentTicket: [],
            tiket: -1,
            groupError: false,
            pageNumber: 0,
            stopSend: false

        };
    }

    get = () => {

        // if (this.props.uData && this.props.uData.lastNotifications) {
        //     let notif = localStorage.getItem('notif') ? JSON.parse(localStorage.getItem('notif')) : [];

        //     for (let i = 0; i < this.props.uData.lastNotifications.length; i++) {
        //         if (notif.indexOf(this.props.uData.lastNotifications[i]._id) == -1) {
        //             notif.push(this.props.uData.lastNotifications[i]._id);
        //         }
        //     }
        //     localStorage.setItem('notif', JSON.stringify(notif));
        //     this.props.verifyUser();
        // }


        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1, user: this.props.uData._id, alias: localStorage.getItem('groupAlias'), group: this.props.selectedGroup, clinic: this.props.selectedClinic })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1, user: this.props.uData._id, alias: localStorage.getItem('groupAlias'), group: this.props.selectedGroup, clinic: this.props.selectedClinic, pageNumber: this.state.pageNumber })).then((data) => {

                if (data && data.doctorTikets && this.state.doctorTikets && this.state.doctorTikets.length) {
                    for (let i = 0; i < data.doctorTikets.length; i++) {
                        for (let j = 0; j < this.state.doctorTikets.length; j++) {
                            if (this.state.doctorTikets[j]._id == data.doctorTikets[i]._id) {
                                this.state.doctorTikets.splice(j, 1)
                            }

                        }

                    }
                    data.doctorTikets = [...this.state.doctorTikets, ...data.doctorTikets]
                }

                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();

        if (!localStorage?.getItem?.('groupAlias') && (this.props.uData.userLevel == 1 || this.props.uData.userLevel == 2)) {
            // this.props[0].history.push(`/home-patient-level`);
            this.setState({
                groupError: true
            })
        }

        this.interval = setInterval(() => {
            this.get();

        }, 60 * 1000);

    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }
    componentDidUpdate(prevProps, prevState) {

        if (prevState.messageModal != this.state.messageModal && this.state.messageModal) {
            if (this.scrollArea) {
                this.scrollArea.scrollTop = this.scrollArea.scrollHeight;
            }
        }
        if (prevProps.selectedGroup != this.props.selectedGroup) {
            this.get();
        }
        if (this.props[0].location && this.props[0].location.state && this.props[0].location.state.messageModal && !this.state.messageModal && this.state.doctorTikets && this.state.doctorTikets.length && !prevState.doctorTikets.length) {
            for (let i = 0; i < this.state.doctorTikets.length; i++) {
                if (this.props[0].location.state.messageModal.toString() == this.state.doctorTikets[i]._id.toString()) {
                    this.setState({
                        messageModal: this.state.doctorTikets[i]
                    }, () => {
                        this.seen(this.state.doctorTikets[i]._id), this.findMessages(this.state.doctorTikets[i]._id)

                    })
                }
            }
        }

    }
    /**
    * Function for ring question to support 
    * @author   Stefan Pantic
    * @Objectparam    {String} message      sent message
    * @Objectparam    {String} subject      queston subject
    * @Objectparam    {String} tiket        support category id
    * @Objectparam    {String} user         user id who send question
    * @Objectparam    {String} alias        group alias
    * @Objectparam    {String} group        group id
    */
    sendQuestion = (data) => {

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/support-category/tiket', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ message: data.message, subject: data.subject, tiket: this.state.tiket, user: this.props.uData._id, alias: localStorage.getItem('groupAlias'), group: this.props.selectedGroup, clinic: this.props.selectedClinic, image: this.state.imageTicket, document: this.state.documentTicket })
            }).then(res => res.json()).then((result) => {
                this.get();
                this.setState({
                    supportModal: null,
                    category: {},
                    image: [],
                    imageTicket: [],
                    documentTicket: [],
                    document: [],
                    tiket: -1,
                    sent: false
                })
            })

        })
    }

    /**
    * Function change seen option on support tickets
    * @author   Stefan Pantic
    * @Objectparam    {String} id      ticket id
    */
    seen = (id) => {

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/support-category/tiket/update/' + id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify()
            }).then(res => res.json()).then((result) => {
                // this.get();

            })

        })

        fetch(API_ENDPOINT + '/notification/seen/update-type', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ type: id, user: this.props.uData._id })
        }).then(res => res.json()).then((result) => {
            this.props.verifyUser()
        })
    }

    /**
    * Function for sending reply on received ticket
    * @author   Stefan Pantic
    * @Objectparam    {String} answer       message that user send
    * @Objectparam    {String} tiket        ticket id
    * @Objectparam    {String} user         user id who send reply
    */
    sendAnswer = (data) => {

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/support-category/answer', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ answer: data.answer, tiket: data._id, user: this.props.uData._id, image: this.state.image, document: this.state.document })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {
                    this.get();

                    let messageModal = this.state.messageModal;
                    messageModal.answer = '';
                    this.setState({
                        messageModal,
                        image: [],
                        document: null,
                        stopSend: false,
                    }, () => this.findMessages(data._id))
                }

            })

        })
    }

    /**
    * Function for file upload
    * @author   Milan Stanojevic
    */
    uploadDocument = (e) => {
        let input = e.target;
        if (input.files) {
            for (let i = 0; i < input.files.length; i++) {
                let document = input.files[i];
                let fsize = document.size;
                let file = Math.round((fsize / 1024))
                this.setState({
                    uploadTimestampDoc: Math.floor(new Date().getTime() / 1000)
                })
                if (file > 10240) {
                    this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
                } else {

                    this.setState({
                        _documentUploading: true
                    })

                    let formData = new FormData();
                    formData.append('file', document);
                    formData.append('group', this.props.selectedGroup)
                    formData.append('fileType', 'clinicSupport')

                    this.props.handleFileUpload?.('/chat/upload/document', formData)?.then?.(img => {
                        if (img) {
                            let documentArr = []
                            documentArr.push(img)
                            if (this.state.newTicket) {
                                this.setState({
                                    documentTicket: [...this.state.documentTicket, ...documentArr],
                                    newTicket: false
                                })
                            } else {
                                if (this.state.document) {
                                    this.setState({
                                        document: [...this.state.document, ...documentArr]
                                    })
                                } else {
                                    this.setState({
                                        document: [...documentArr]
                                    })
                                }
                            }

                            this.setState({
                                _documentUploading: null
                            })
                        }
                    });

                    // fetch(API_ENDPOINT + '/chat/upload/document', {
                    //     method: 'POST',
                    //     headers: {
                    //         Accept: 'application/json',
                    //         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    //     },
                    //     body: formData
                    // }).then(parseJSONUpload).then((img) => {
                    //     if (img?.error) {
                    //         this.setState({ error: img.error, _documentUploading: null })
                    //     } else {
                    //         let documentArr = []
                    //         documentArr.push(img)
                    //         if (this.state.newTicket) {
                    //             this.setState({
                    //                 documentTicket: [...this.state.documentTicket, ...documentArr],
                    //                 newTicket: false
                    //             })
                    //         } else {
                    //             if (this.state.document) {
                    //                 this.setState({
                    //                     document: [...this.state.document, ...documentArr]
                    //                 })
                    //             } else {
                    //                 this.setState({
                    //                     document: [...documentArr]
                    //                 })
                    //             }
                    //         }

                    //         this.setState({
                    //             _documentUploading: null
                    //         })
                    //     }

                    // });
                }
            }
        }
    }

    /**
    * Function for image upload
    * @author   Milan Stanojevic
    */
    uploadImage = (e) => {
        let input = e.target;
        if (input.files) {
            for (let i = 0; i < input.files.length; i++) {
                let image = input.files[i];
                let fsize = image.size;
                let file = Math.round((fsize / 1024))

                this.setState({
                    uploadTimestamp: Math.floor(new Date().getTime() / 1000)
                })
                if (file > 10240) {
                    this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
                } else {

                    this.setState({
                        _imageUploading: true
                    })
                    console.log(image);
                    let formData = new FormData();

                    formData.append('file', image);
                    formData.append('group', this.props.selectedGroup)
                    formData.append('fileType', 'clinicSupport')
                    console.log(formData);

                    this.props.handleFileUpload?.('/chat/upload/image', formData)?.then?.(img => {
                        if (img) {
                            let imageArr = []
                            imageArr.push(img)
                            // console.log(imageArr);
                            if (this.state.newTicket) {
                                this.setState({
                                    imageTicket: [...this.state.imageTicket, ...imageArr],
                                    newTicket: false
                                })
                            } else {
                                if (this.state.image) {
                                    this.setState({
                                        image: [...this.state.image, ...imageArr]
                                    })
                                } else {
                                    this.setState({
                                        image: [...imageArr]
                                    })
                                }
                            }
                            this.setState({
                                _imageUploading: null,
                            })
                        }
                    })

                    // fetch(API_ENDPOINT + '/chat/upload/image', {
                    //     method: 'POST',
                    //     headers: {
                    //         Accept: 'application/json',
                    //         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    //     },
                    //     body: formData
                    // }).then(parseTextUpload).then((img) => {
                    //     if (img?.error) {
                    //         this.setState({ error: img.error, _imageUploading: null })
                    //     } else {
                    //         let imageArr = []
                    //         imageArr.push(img)
                    //         // console.log(imageArr);
                    //         if (this.state.newTicket) {
                    //             this.setState({
                    //                 imageTicket: [...this.state.imageTicket, ...imageArr],
                    //                 newTicket: false
                    //             })
                    //         } else {
                    //             if (this.state.image) {
                    //                 this.setState({
                    //                     image: [...this.state.image, ...imageArr]
                    //                 })
                    //             } else {
                    //                 this.setState({
                    //                     image: [...imageArr]
                    //                 })
                    //             }
                    //         }
                    //         this.setState({
                    //             _imageUploading: null,
                    //         })
                    //     }

                    // });
                }
            }
        }
    }

    findMessages = (id) => {

        console.log('sssssssssssssss', id);
        fetch(API_ENDPOINT + '/support-category/all-messages/' + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({})
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang)
                })
            } else {

                this.setState({
                    messages: result
                })
            }

        })
    }

    notifSeenUpdate = (id) => {
        console.log('gdshgsahjdhsadsahdsah', id);
        fetch(API_ENDPOINT + '/notification/seen/update-type', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ type: id, user: this.props.uData ? this.props.uData._id : null })
        }).then(res => res.json()).then((result) => {
            console.log('result0', result);
            this.props.verifyUser()
        })
    }

    pickUpTicket = (data) => {
        // console.log(id);
        fetch(API_ENDPOINT + '/sent-support-ticket/update/' + data._id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ pickUp: true, user: this.props.uData._id })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.get()

                this.setState({
                    messageModal: result
                }, () => {

                })
            }

        })
    }

    render() {
        // let params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })

        // console.log(this.state.documentTicket)
        let level = this.props.uData.userLevel
        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                {this.state._imageUploading || this.state._documentUploading ?
                    <div className="file-progress-loader">
                        <div>
                            <Player
                                onEvent={(event) => {
                                    if (event === "load" && this.player && this.player.current) this.player.current.play();
                                }}
                                ref={this.player} // set the ref to your class instance
                                autoplay={true}
                                loop={true}
                                controls={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                renderer={'svg'}
                                style={{ height: "128px", width: "128px", }}
                            ></Player>
                            <h6>{'Processing file...'.translate(this.props.lang)}</h6>
                        </div>

                    </div>
                    : null
                }
                <Container fluid>
                    <div className="panel select-clinics-wrapper">
                        <h5 className="component-header mb-35">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>
                        {level > 20 ?
                            null
                            :
                            <Col lg="4" className="ml-0">
                                <Button className="news-ticket-button" onClick={() => this.setState({ supportModal: true })}>{'Open new tiket'.translate(this.props.lang)}</Button>
                            </Col>

                        }
                        <Row>
                            {this.state.sentList ?
                                <Col lg="4">
                                    <div className={typeof window != 'undefined' && window.innerWidth < 768 && this.state.displayNone ? "support-ticket-none" : "support-ticket2"}>

                                        <>
                                            {this.state.doctorTikets && this.state.doctorTikets.length ? this.state.doctorTikets.sort(function (a, b) {
                                                if (!a.seenUser && b.seenUser) return -1;
                                                if (a.seenUser && !b.seenUser) return 1;
                                                return b.timestemp - a.timestemp
                                            }).sort(function (a, b) { return a.close - b.close }).map(item => {

                                                return (

                                                    <button className={this.state.messageModal && this.state.messageModal._id == item._id ? item.close ? 'ticket-closed active-ticket-red' : item.supportUserWhoTakeTicket ? 'ticked-open active-ticket-green' : 'ticket-inprogress active-ticket-inprogress' : item.close ? 'ticket-closed' : item.supportUserWhoTakeTicket ? 'ticked-open' : 'ticket-inprogress'} onClick={() => this.setState({ messageModal: null }, () => { this.setState({ messageModal: item, displayNone: true }, () => { this.seen(item._id), this.findMessages(item._id), this.notifSeenUpdate(item._id) }) })}>
                                                        <h6>{item.name ? item.name : 'Site - support'}</h6>
                                                        <h6>{'Support-ID:'.translate(this.props.lang)} {item.tiketNumber} - {item.subject ? item.subject : 'Site'}</h6>
                                                        <h6>{'Clinic:'.translate(this.props.lang)} {item.clinicName ? item.clinicName : item.organization ? item.organization : ''}</h6>
                                                        {item.userWhoCreatedTicket && item.userWhoCreatedTicket.toString() != this.props.uData._id.toString() ? !item.seenSupport ? <p className="ticket-notification"></p> : '' : !item.seenUser && item.userWhoCreatedTicket ? <p className="ticket-notification"></p> : item.userWhoCreatedTicket ? '' : !item.seenSupport ? <p className="ticket-notification"></p> : ''}
                                                        <p style={{ fontWeight: 600, color: '#3A3F56', textAlign: 'left' }}>{item.email ? `${'E-mail'.translate(this.props.lang)}: ${item.email}` : null}</p>
                                                        <h6 style={{ lineHeight: 0, display: 'block', marginBottom: 20 }}> {item.phone ? <p>{'Phone'.translate(this.props.lang)}: {item.phone}</p> : null}</h6>
                                                        <div className="ticket-body">
                                                            {item.profilePicture ?
                                                                <img src={API_ENDPOINT + item.profilePicture} />

                                                                :
                                                                <img src={profileUser} />

                                                            }
                                                            <h6>{item.userName ? item.userName : item.name ? item.name : ''}</h6>
                                                            <p>{this.props.getStringDateTs(item.timestemp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.timestemp).format(`${this.props.dateFormat} HH:mm`)*/}</p>
                                                        </div>
                                                        {item.site && !item.pickUp ? <Button className={'close-support-button-text'} style={{ marginLeft: 20 }} onClick={() => this.pickUpTicket(item)}>{'Pick up support ticket'.translate(this.props.lang)}</Button> : null}
                                                    </button>
                                                )
                                            })
                                                : null}
                                        </>
                                    </div>
                                    {!(typeof window != 'undefined' && window.innerWidth < 768 && this.state.messageModal) ?
                                        <Button color='primary' onClick={() => this.setState({ pageNumber: this.state.pageNumber + 1 }, () => this.get())} >{'Load more'.translate(this.props.lang)}</Button>
                                        : null}
                                </Col>
                                :
                                null}
                            <Col lg="8">
                                <div className="ticket-answer" ref={(node) => this.scrollArea = node} style={{ height: (!this.state.messageModal && typeof window != 'undefined' && window.innerWidth < 768) ? 0 : 'auto' }}>
                                    {this.state.messageModal && typeof window != 'undefined' && window.innerWidth > 768 ?
                                        <div className="ticket-message-tab-container">

                                            {this.state.messages && this.state.messages.length && this.state.messages.sort(function (a, b) { return a.timestemp - b.timestemp }).map(item => {
                                                // console.log(item);
                                                return (
                                                    <div className="mesage-box">
                                                        <div className="message-header">
                                                            <div className="message-header-container">
                                                                {item.profilePicture ?
                                                                    <img src={API_ENDPOINT + item.profilePicture} />

                                                                    :
                                                                    <img src={profileUser} />

                                                                }
                                                                <h6>{item.user ? item.user : ''}</h6>
                                                            </div>
                                                            <p>{this.props.getStringDateTs(item.timestemp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.timestemp).format(`${this.props.dateFormat} HH:mm`)*/}</p>
                                                        </div>
                                                        <p>
                                                            {item.message}
                                                            <div >
                                                                {item.image && item.image.length && typeof item.image == 'object' ?
                                                                    item.image.map(img => {

                                                                        return (
                                                                            <a className='attach-icon' target='_blank' href={API_ENDPOINT + img}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a>
                                                                        )

                                                                    })
                                                                    :
                                                                    item.image && item.image.length > 0 ?
                                                                        <a className='attach-icon' target='_blank' href={API_ENDPOINT + item.image}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    item.document && item.document.length && typeof item?.document == 'object' ?
                                                                        item.document.map(doc => {
                                                                            return (
                                                                                <div className="document" style={{ paddingLeft: 0, marginTop: 0 }}><a style={{ marginTop: 0 }} className='attach-icon' target="_blank" download href={API_ENDPOINT + doc.file}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a></div>
                                                                            )
                                                                        })
                                                                        :
                                                                        item.document && item.document.file ?
                                                                            <div className="document" style={{ paddingLeft: 0, marginTop: 0 }}><a style={{ marginTop: 0 }} className='attach-icon' target="_blank" download href={API_ENDPOINT + item.document.file}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a></div>
                                                                            :
                                                                            null
                                                                }
                                                            </div>
                                                            {/* <div>
                                                            </div> */}
                                                        </p>
                                                    </div>

                                                )
                                            })}

                                            {this.state.messageModal.close || (!this.state.messageModal.pickUp && this.state.messageModal.site) ?
                                                null
                                                : <FormGroup className="ticket-message-group ticket-message-tab">
                                                    <Label>{'Message'.translate(this.props.lang)}</Label>
                                                    <Input type='textarea' rows="6" className="textarea-six-row" onChange={(e) => {
                                                        let messageModal = this.state.messageModal;
                                                        messageModal.answer = e.target.value;
                                                        this.setState({
                                                            messageModal
                                                        })
                                                    }} value={this.state.messageModal.answer} />
                                                </FormGroup>}
                                            <div style={{ background: 'white' }}>
                                                {/* {this.state.image && this.state.image.length ?
                                                    this.state.image.map(img => {
                                                        return (
                                                            <a className='attach-icon' target='_blank' href={API_ENDPOINT + img}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a>
                                                        )
                                                    })
                                                    :
                                                    null} */}
                                                {
                                                    this.state.document && this.state.document.length ?
                                                        this.state.document.map(doc => {
                                                            if (doc && doc.file)
                                                                return (
                                                                    <div className="document" style={{ paddingLeft: 0, marginTop: 0 }}><a target="_blank" download href={API_ENDPOINT + doc.file}><Isvg src={attach} style={{ width: 20, height: 20 }} />{'Open attachment'.translate(this.props.lang)}</a></div>
                                                                )
                                                        })

                                                        :
                                                        null
                                                }
                                            </div>

                                            {/* {this.state.messageModal.close || !this.state.messageModal.clinic || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                <Button color="primary" style={{ marginBottom: 20, marginRight: 10 }} className={this.state._documentUploading ? 'attach uploading' : this.state.document ? 'attach uploaded' : "attach"} onClick={() => { if (this.documentInput) this.documentInput.click() }}>
                                                    {'Attach file'.translate(this.props.lang)}
                                                </Button>} */}
                                            {this.state.messageModal.close || !this.state.messageModal.clinic || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                <Button color="primary" style={{ marginBottom: 20, marginRight: 10 }} className={this.state._imageUploading ? 'image uploading' : this.state.image ? 'image uploaded' : "image"} onClick={() => { /*if (this.imageInput) this.imageInput.click() */ this.setState({ attachFile: true }) }}>
                                                    {'Attach files'.translate(this.props.lang)}
                                                </Button>}
                                            {this.state.messageModal.close || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                <Button className="news-ticket-button" disabled={this.state.messageModal.answer || this.state.image ? this.state.messageModal.answer != '' || this.state.image.length > 0 ? false : true : true} onClick={() => {
                                                    if (!this.state.stopSend)
                                                        this.setState({ stopSend: true }, () => { this.sendAnswer(this.state.messageModal) })
                                                }}>{'Send'.translate(this.props.lang)}</Button>
                                            }
                                        </div>
                                        : this.state.messageModal && typeof window != 'undefined' && window.innerWidth < 768 ?
                                            <div className="ticket-message-tab-container ticket-message-tab-container-fixed">
                                                <button className="support-back-button" onClick={() => { this.setState({ displayNone: false, messageModal: !this.state.messageModal }) }}>{'Back'.translate(this.props.lang)}</button>
                                                {this.state.messages && this.state.messages.length && this.state.messages.sort(function (a, b) { return a.timestemp - b.timestemp }).map(item => {
                                                    return (
                                                        <div className="mesage-box">
                                                            <div className="message-header">
                                                                <div className="message-header-container">
                                                                    {item.profilePicture ?
                                                                        <img src={API_ENDPOINT + item.profilePicture} />

                                                                        :
                                                                        <img src={profileUser} />

                                                                    }
                                                                    <h6>{item.user ? item.user : ''}</h6>
                                                                </div>
                                                                <p>{this.props.getStringDateTs(item.timestemp, `${this.props.dateFormat} HH:mm`)/*moment.unix(item.timestemp).format(`${this.props.dateFormat} HH:mm`)*/}</p>
                                                            </div>
                                                            <p>
                                                                {item.message}
                                                                <div >
                                                                    {item.image && item.image.length && typeof item.image == 'object' ?
                                                                        item.image.map(img => {
                                                                            return (
                                                                                <a className='attach-icon' target='_blank' href={API_ENDPOINT + img}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a>
                                                                            )

                                                                        })
                                                                        :
                                                                        item.image && item.image.length > 0 ?
                                                                            <a className='attach-icon' target='_blank' href={API_ENDPOINT + item.image}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        item.document && item.document.length && typeof item?.document == 'object' ?
                                                                            item.document.map(doc => {
                                                                                console.log(doc.file);
                                                                                return (
                                                                                    <div className="document" style={{ paddingLeft: 0, marginTop: 0 }}><a style={{ marginTop: 0 }} className='attach-icon' target="_blank" download href={API_ENDPOINT + doc.file}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a></div>
                                                                                )
                                                                            })
                                                                            :
                                                                            item.document && item.document.length > 0 ?
                                                                                <div className="document" style={{ paddingLeft: 0, marginTop: 0 }}><a className='attach-icon' target="_blank" download href={API_ENDPOINT + item.document.file}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a></div>
                                                                                :
                                                                                null
                                                                    }
                                                                </div>
                                                            </p>
                                                        </div>

                                                    )
                                                })}

                                                {this.state.messageModal.close || (!this.state.messageModal.pickUp && this.state.messageModal.site) ?
                                                    null
                                                    : <FormGroup className="ticket-message-group ticket-message-tab">
                                                        <Label>{'Message'.translate(this.props.lang)}</Label>
                                                        <Input type='textarea' rows="6" className="textarea-six-row" onChange={(e) => {
                                                            let messageModal = this.state.messageModal;
                                                            messageModal.answer = e.target.value;
                                                            this.setState({
                                                                messageModal
                                                            })
                                                        }} value={this.state.messageModal.answer} />
                                                    </FormGroup>}
                                                <div style={{ background: 'white' }}>
                                                    {this.state.image ? <a className='attach-icon' target='_blank' href={API_ENDPOINT + this.state.image}><Isvg src={attach} style={{ width: 20, height: 20 }} /><span>{'Open attachment'.translate(this.props.lang)}</span></a> : null}
                                                    {
                                                        Array.isArray(this.state.document) && this.state.document.length > 0 ?
                                                            this.state.document
                                                                .filter(doc => doc !== null && doc !== undefined && doc.file)
                                                                .map((doc, index) => {
                                                                    return (
                                                                        <div className="document" style={{ paddingLeft: 0, marginTop: 0 }} key={index}>
                                                                            <a target="_blank" download href={API_ENDPOINT + doc.file}>
                                                                                <Isvg src={attach} style={{ width: 20, height: 20 }} />
                                                                                {'Open attachment'.translate(this.props.lang)}
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                })
                                                            :
                                                            null
                                                    }

                                                </div>
                                                <div className="chat-buttons-footer-support">
                                                    {this.state.messageModal.close || !this.state.messageModal.clinic || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                        <Button color="primary" style={{ marginBottom: 20, marginRight: 10 }} className={this.state._documentUploading ? 'attach uploading' : this.state.document ? 'attach uploaded' : "attach"} onClick={() => { if (this.documentInput) this.documentInput.click() }}>
                                                            {'Attach files'.translate(this.props.lang)}
                                                        </Button>}
                                                    {/* {this.state.messageModal.close || !this.state.messageModal.clinic || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                        <Button color="primary" style={{ marginBottom: 20, marginRight: 10 }} className={this.state._imageUploading ? 'image uploading' : this.state.image ? 'image uploaded' : "image"} onClick={() => { if (this.imageInput) this.imageInput.click() }}>
                                                            {'Attach image'.translate(this.props.lang)}
                                                        </Button>} */}
                                                    {this.state.messageModal.close || (!this.state.messageModal.pickUp && this.state.messageModal.site) ? null :
                                                        <Button className="news-ticket-button" disabled={this.state.messageModal.answer || this.state.image ? this.state.messageModal.answer != '' || this.state.image.length > 0 ? false : true : true} onClick={() => {
                                                            if (!this.state.stopSend)
                                                                this.setState({ stopSend: true }, () => { this.sendAnswer(this.state.messageModal) })
                                                        }}>{'Send'.translate(this.props.lang)}</Button>}
                                                </div>
                                            </div>
                                            : null}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>

                {this.state.supportModal ?
                    <Modal isOpen={this.state.supportModal} centered>
                        <ModalHeader toggle={() => this.setState({ supportModal: !this.state.supportModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ supportModal: !this.state.supportModal, category: {}, imageTicket: null, documentTicket: null })}>&times;</button>}>{'Your question'.translate(this.props.lang)}</ModalHeader>
                        <ModalBody>

                            <Input type='select'
                                className="mb-20"
                                value={this.state.tiket}
                                onChange={e => this.setState({ tiket: e.target.value }, () => { this.get() })}>
                                <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                {this.state.items.map(item => {
                                    return <option value={item._id}>
                                        {item.name}
                                    </option>
                                })}

                            </Input>
                            <FormGroup>
                                <Label>{'Subject'.translate(this.props.lang)}</Label>
                                <Input type='text' onChange={(e) => {
                                    let category = this.state.category;
                                    category.subject = e.target.value;
                                    this.setState({
                                        category
                                    })
                                }} value={this.state.category.subject} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Message'.translate(this.props.lang)}</Label>

                                <Input type='textarea' rows="6" className="textarea-six-row" onChange={(e) => {
                                    let category = this.state.category;
                                    category.message = e.target.value;

                                    this.setState({
                                        category
                                    })
                                }} value={this.state.category.message} />
                            </FormGroup>
                            <div>

                                {
                                    Array.isArray(this.state.documentTicket) && this.state.documentTicket.length > 0 ?
                                        this.state.documentTicket
                                            .filter(doc => doc !== null && doc !== undefined && doc.file)
                                            .map((doc, index) => {
                                                return (
                                                    <div className="document" key={index}>
                                                        <a
                                                            className='attach-icon'
                                                            style={{ lineBreak: 'anywhere' }}
                                                            target="_blank"
                                                            download
                                                            href={API_ENDPOINT + doc.file}
                                                        >
                                                            <Isvg src={attach} />
                                                            <span>{doc.fileName}</span>
                                                        </a>
                                                    </div>
                                                );
                                            })
                                        :
                                        null
                                }

                            </div>


                        </ModalBody>
                        <ModalFooter className='buttons-right-blue'>
                            {/* <Button color="primary" style={{ margin: 10 }} className={this.state._documentUploading ? 'attach uploading' : this.state.documentTicket ? 'attach uploaded' : "attach"} onClick={() => this.setState({ newTicket: true }, () => { if (this.documentInput) this.documentInput.click() })}>
                                <div className='chat-icons-tooltip'>
                                    {'Attach file'.translate(this.props.lang)}
                                </div>
                            </Button>
                            <Button color="primary" style={{ margin: 10 }} className={this.state._imageUploading ? 'image uploading' : this.state.imageTicket ? 'image uploaded' : "image"} onClick={() => this.setState({ newTicket: true }, () => { if (this.imageInput) this.imageInput.click() })}>
                                <div className='chat-icons-tooltip'>
                                    {'Attach image'.translate(this.props.lang)}
                                </div>
                            </Button> */}

                            <Button color="primary" style={{ margin: 10 }} className={this.state._imageUploading ? 'image uploading' : this.state.image ? 'image uploaded' : "image"} onClick={() => { /*if (this.imageInput) this.imageInput.click() */ this.setState({ attachFile: true }) }}>
                                {'Attach files'.translate(this.props.lang)}
                            </Button>


                            <Button color="primary" style={{ margin: 10 }} disabled={this.state.category.message && this.state.category.subject && this.state.tiket != -1 && !this.state.sent ? false : true} onClick={() => this.setState({
                                sent: true
                            }, () => this.sendQuestion(this.state.category))}>{'Send'.translate(this.props.lang)}</Button>
                        </ModalFooter>
                    </Modal>
                    : null}

                <input ref={(node) => this.documentInput = node} type="file" title={"No file chosen".translate(this.props.lang)} accept=".doc, .docx, .pdf" key={this.state.uploadTimestampDoc} onChange={this.uploadDocument} multiple style={{ pointerEvents: 'none', opacity: 0 }} />
                <input ref={(node) => this.imageInput = node} type="file" title={"No file chosen".translate(this.props.lang)} accept="image/png, image/jpeg, image/jpg, image/gif, image/svg" key={this.state.uploadTimestamp} onChange={this.uploadImage} multiple style={{ pointerEvents: 'none', opacity: 0 }} />


                {this.state.error ? (
                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>
                ) : null}
                {this.state.groupError ? (
                    <Modal isOpen={this.state.groupError} centered>
                        {/* <ModalHeader>{'Error'.translate(this.props.lang)}</ModalHeader> */}
                        <ModalBody className="delete-modal">
                            {/* <img src={warrning} /> */}
                            <p className="message">{'You have to select the group!'.translate(this.props.lang)}</p>
                        </ModalBody>

                        <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button style={{ minWidth: 100 }} onClick={() => {
                                this.props[0].history.push(`/home-patient-level`);
                            }}>{'Close'.translate(this.props.lang)}</Button>
                        </ModalFooter>
                    </Modal>
                ) : null}


                <Modal isOpen={this.state.attachFile} centered>
                    <ModalHeader toggle={() => this.setState({ attachFile: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ attachFile: null })}>&times;</button>}>{'Upload file'.translate(this.props.lang)}</ModalHeader>
                    <ModalBody>

                        <FormGroup tag="fieldset">
                            <File group={this.props.selectedGroup} lang={this.props.lang} onChange={(files) => {
                                if (this.state.supportModal) {
                                    this.setState({
                                        documentTicket: files,

                                    })
                                } else {
                                    if (this.state.document) {
                                        this.setState({
                                            document: files
                                        })
                                    } else {
                                        this.setState({
                                            document: files
                                        })
                                    }
                                }

                            }} value={this.state.supportModal ? this.state.documentTicket : this.state.document} />

                        </FormGroup>

                    </ModalBody>
                    <ModalFooter className='buttons-right-blue'>
                        <Button color="primary" style={{ margin: 10 }} className={this.state._documentUploading ? 'attach uploading' : this.state.documentTicket ? 'attach uploaded' : "attach"} onClick={() => {
                            this.setState({ attachFile: null })
                        }}>
                            <div className='chat-icons-tooltip'>
                                {'Attach'.translate(this.props.lang)}
                            </div>
                        </Button>
                    </ModalFooter>
                </Modal>

            </div>



        );


    }
}

export default Page(HomePage);